// extracted by mini-css-extract-plugin
module.exports = {"container":"nVSEA","textComment":"QpKGD","label":"_8cOdN","textCommentIcon":"_2kMvl"};